import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const OwncloudIcon = createSvgIcon(
 <svg
  width="800px"
  height="800px"
  viewBox="-10 -5 1034 1034"
  xmlns="http://www.w3.org/2000/svg"
  version="1.1">
  <path
   fill="#1d2d44"
   d="M453 320q-37 0 -68 18t-49 49t-18 68q0 45 28 81q28 -33 68 -51.5t85 -18.5t85 18q3 -15 3 -29q0 -37 -18 -68t-49 -49t-67 -18zM277 382q-29 0 -49.5 21t-20.5 50q0 18 9 34q37 -21 79 -21l9 1l-1 -12q0 -32 13 -61q-18 -12 -39 -12zM609 431h-6h-3q3 14 3 24
 q0 18 -5 36q52 29 81 81q30 -16 63 -18q-3 -34 -21 -62t-47.5 -44.5t-64.5 -16.5zM500 481q-52 0 -95 25.5t-68.5 68.5t-25.5 94t25.5 94.5t68.5 69t94.5 25.5t94.5 -25.5t68.5 -69t25.5 -94.5t-25.5 -94t-68.5 -68.5t-94 -25.5zM295 482q-39 0 -73 19.5t-53.5 53
 t-19.5 73.5q0 35 15.5 65.5t42.5 50.5q11 -22 32 -35t47 -13q4 0 12 1q-2 -13 -2 -28q0 -67 40 -121q-24 -29 -30 -66h-11zM753 569q-35 0 -68 17q19 40 18 83q1 41 -15 78t-43 66q20 22 48.5 35t59.5 13q40 0 73.5 -19.5t53 -53t19.5 -73.5t-19.5 -73.5t-53 -53
 t-73.5 -19.5zM130 588h-1h-1q-35 2 -64.5 20.5t-46.5 48.5t-17 66t18 67t49 49t68 18q42 0 76 -24q-14 -22 -14 -48q0 -13 4 -26q-31 -23 -49 -57t-18 -74q0 -20 5 -40h-9zM926 704q-5 0 -11 1v10q0 31 -12 59.5t-33 50.5q23 26 56 26q31 0 52.5 -21.5t21.5 -52t-21.5 -52
 t-52.5 -21.5zM286 711q-31 0 -52.5 22t-21.5 52.5t21.5 52t52.5 21.5q23 0 41.5 -13t26.5 -34q-41 -42 -53 -99q-8 -2 -15 -2z"
  />
 </svg>,
 "Owncloud"
);
